import React from 'react'
import SpinnerIcon from '../../../../../../common/icons/spiner'
import DoneIcon from '../../../../../../common/icons/done'
import { Box, Typography } from '@mui/material'
import ProhibitIcon from '../../../../../../common/icons/prohibit'

const statusConfig = {
  VERIFIED: {
    icon: <DoneIcon />,
    color: '#00BC62',
    label: 'Verified'
  },
  IN_PROGRESS: {
    icon: <SpinnerIcon color={'#F57D1B'} />,
    color: '#F57D1B',
    label: 'In progress'
  },
  NOT_VERIFIED: {
    icon: <ProhibitIcon />,
    color: '#F0284C',
    label: 'Not verified'
  }
}

export default function StatusBlock({ status }) {
  const currentStatus = statusConfig[status]
  const { icon, color, label } = currentStatus

  return (
    <Box display={'flex'} columnGap={1} alignItems={'center'}>
      {icon}
      <Typography color={color} sx={{ fontWeight: 400, fontSize: '14px', fontFamily: 'Plus Jakarta Sans' }}>
        {label}
      </Typography>
    </Box>
  )
}
